<template>
  <div>
    <b-modal
      id="modal_novo_itens"
      title="Adicionar Produto"
      ref="my-modal"
      size="lg"
      hide-footer
      modal-class="modal-add-product"
      @show="resetModal"
      @hidden="resetModal"
      scrollable
    >
      <!-- Client Info Bar -->
      <div v-if="getFormData && getFormData.cliente" class="client-info-bar">
        <div class="client-info">
          <feather-icon icon="UserIcon" size="16" />
          <div class="info-content">
            <span class="label">CLIENTE</span>
            <span class="value">{{ getFormData.cliente.clientenomeabreviado || 'Cliente' }}</span>
          </div>
        </div>

        <div class="order-info">
          <div class="info-item" v-if="getFormData.dataCapaPedido">
             <feather-icon icon="TagIcon" size="16" />
             <div class="info-content">
               <span class="label">TABELA</span>
               <span class="value">{{ getFormData.dataCapaPedido.tabelaprecoid || '-' }}</span>
             </div>
          </div>
          <div class="info-item">
            <feather-icon icon="ShoppingCartIcon" size="16" />
            <div class="info-content">
               <span class="label">ITENS</span>
               <span class="value">{{ totalItensNoPedido }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Busca simples: texto + filtros de atributo -->
      <div class="filtros-busca mt-1">
        <b-row class="gx-2">
          <b-col cols="12">
            <b-form-group label="Buscar por ISBN, SKU ou nome do produto">
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <b-spinner small variant="success" v-show="getIsLoadingReferencia" />
                  <feather-icon icon="SearchIcon" size="18" v-if="!getIsLoadingReferencia" />
                </b-input-group-prepend>
                <b-form-input
                  v-model="filtroTexto"
                  placeholder="Digite o ISBN, SKU ou nome do produto (opcional)"
                  :disabled="isLoadingAllData"
                  @keyup.enter="buscarPorFiltros"
                />
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="gx-2 align-items-end">
          <b-col cols="12" sm="6" md="2" v-if="filtrosOptions.lingua.length">
            <b-form-group label="Língua" class="filtro-atributo-group">
              <b-form-select v-model="filtroLingua" :disabled="isLoadingAllData"
                :options="[{ value: null, text: 'Todas' }, ...filtrosOptions.lingua]" />
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="2" v-if="filtrosOptions.segmento.length">
            <b-form-group label="Segmento" class="filtro-atributo-group">
              <b-form-select v-model="filtroSegmento" :disabled="isLoadingAllData"
                :options="[{ value: null, text: 'Todos' }, ...filtrosOptions.segmento]" />
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="2" v-if="filtrosOptions.marcas.length > 1">
            <b-form-group label="Marca" class="filtro-atributo-group">
              <b-form-select v-model="filtroMarca" :disabled="isLoadingAllData"
                :options="[{ value: null, text: 'Todas' }, ...filtrosOptions.marcas.map((m) => ({ value: m.cod_marca, text: m.des_marca }))]" />
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="2" v-if="filtrosOptions.niveleducacional.length">
            <b-form-group label="Nível educacional" class="filtro-atributo-group">
              <b-form-select v-model="filtroNivel" :disabled="isLoadingAllData"
                :options="[{ value: null, text: 'Todos' }, ...filtrosOptions.niveleducacional]" />
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="2" v-if="filtrosOptions.colecao.length">
            <b-form-group label="Coleção" class="filtro-atributo-group">
              <b-form-select v-model="filtroColecao" :disabled="isLoadingAllData"
                :options="[{ value: null, text: 'Todas' }, ...filtrosOptions.colecao]" />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="2" class="d-flex align-items-end">
            <b-form-group label=" " class="w-100 mb-1">
              <div class="d-flex" style="gap: 6px;">
                <b-button
                  variant="primary"
                  class="flex-grow-1"
                  :disabled="isLoadingAllData"
                  @click="buscarPorFiltros"
                >
                  <feather-icon icon="SearchIcon" size="16" class="mr-25" />
                  Buscar
                </b-button>
                <b-button
                  variant="outline-danger"
                  :disabled="isLoadingAllData"
                  @click="limparFiltrosAtributo"
                >
                  <feather-icon icon="TrashIcon" size="16" />
                </b-button>
              </div>
            </b-form-group>
          </b-col>
        </b-row>
      </div>

      <!-- Totais -->
      <b-row class="justify-content-end mt-3">
        <b-col cols="auto" class="text-right">
          <p><strong>Total de Pedidos:</strong> {{ totalUnidades }}</p>
          <p>
            <strong>Custo Total:</strong>
            {{ dinheiroVisual(totalVisualItens) }}
          </p>
        </b-col>
      </b-row>

      <!-- Loading -->
      <div v-if="isLoadingAllData" class="loading-indicator text-center my-2">
        <b-spinner small type="grow" class="mr-2"></b-spinner>
        Carregando mais itens...
      </div>

      <!-- Inserção de Itens -->
      <inserir-item-modal
        :cotacoes-preco-visuais="cotacoesVisuais"
        :before-add-item="prepararItemParaAdicionar"
        :tipo-pedido-id="categoriaPedidoPersistida()"
        :manages-client-category="categoriaClienteAtiva()"
        @update:grade-item="updatedGradeItens"
        @calcular-imposto="calcularImposto"
        @remove-item="handleRemoveItem"
        @select-item="carregarDetalheReferencia"
      />

      <!-- Carregar mais itens (lazy/paginado + scroll infinito) -->
      <div v-if="temMaisReferencias" class="text-center my-2">
        <!-- Sentinela do IntersectionObserver: dispara o próximo bloco ao chegar perto do fim -->
        <div ref="sentinelaCarregarMais" class="sentinela-carregar-mais"></div>
        <!-- Indicador discreto no fim da lista durante o auto-load por scroll -->
        <div v-if="isLoadingAllData" class="loading-indicator text-center my-2">
          <b-spinner small type="grow" class="mr-2"></b-spinner>
          Carregando mais itens...
        </div>
        <b-button v-else variant="outline-primary" @click="carregarMaisReferencias">
          <feather-icon icon="ChevronDownIcon" size="16" class="mr-50" />
          Carregar mais itens ({{ referenciasPendentes.length }} restantes)
        </b-button>
      </div>

      <div class="modal-actions-footer">
        <div class="items-summary" v-if="itensTabela.length > 0">
          <span class="summary-count">{{ itensTabela.length }} item(s)</span>
          <span class="summary-separator">|</span>
          <span class="summary-total">{{ dinheiroVisual(totalVisualItens) }}</span>
        </div>
        <div class="actions-buttons" :class="{ 'ml-auto': itensTabela.length === 0 }">
           <b-button variant="outline-secondary" @click="$refs['my-modal'].hide()">
             <feather-icon icon="XIcon" size="16" class="mr-50" />
             Cancelar
           </b-button>
           <b-button variant="success" @click="handleOk" :disabled="!podeSalvarItens">
             <feather-icon icon="CheckIcon" size="16" class="mr-50" />
             Salvar
           </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BModal, BFormSelect, BFormInput, BCol, BButton, BInputGroup, BInputGroupPrepend,
} from 'bootstrap-vue';
import { mapActions, mapGetters } from 'vuex';
import ProductionItem from '@/views/app/operacoes/pedidosVendas/swipper/swipperItensProdutos.vue';
import GradePedidos from '@/views/app/operacoes/pedidosVendas/tabelaGrade/gradePedidos.vue';
import apiAxios from '@/libs/axios';
import ECommerceProductDetails from '@/views/app/CartECommerce/e-commerce-product-details/ECommerceProductDetails.vue';
import InserirItemModal from '@/views/app/operacoes/pedidosVendas/inserirItemModal.vue';
import Swal from 'sweetalert2';
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';
import { aplicarPrecoDoacao, isPedidoDoacao } from '@/utils/impostoSimulador';
import { precoComDescontoConfirmado, precoFinalSimulado, precoTabelaSimulado } from '@/utils/precoProveniencia';
import SLSEstoqueService from '@/services/SistemaDKP/SLSEstoque.service';
import adicionarProdutoModalMixin from './adicionarProdutoModal.mixin';
import categoriaPedidoClienteMixin from './categoriaPedidoCliente.mixin';

export default {
  components: {
    InserirItemModal,
    ECommerceProductDetails,
    GradePedidos,
    BButton,
    BFormInput,
    BModal,
    BCol,
    BFormSelect,
    ProductionItem,
    BInputGroup,
    BInputGroupPrepend,
  },
  mixins: [adicionarProdutoModalMixin, categoriaPedidoClienteMixin],
  data() {
    return {
      typeModal: null,
      categoryCalculationGeneration: 0,
      preparandoAdicao: false,
    };
  },
  computed: {
    podeSalvarItens() {
      return this.novosItensAdicionados && !this.preparandoAdicao && !this.isCalculandoImposto
        && this.itensTabela.length > 0
        && this.itensTabela.every(item => Number.isFinite(Number(item.precoComImposto))
          && Number(item.precoComImposto) > 0);
    },
    ...mapGetters('SLS_PedidosVendas', [
      'getCapaPedido',
      'getItensPedido',
      'getEnderecoEntrega',
    ]),
  },
  methods: {
    ...mapActions('SLS_PedidosVendas', [
      'setItensTabelaPedido',
    ]),
    getTabelaPrecoId() {
      return this.getCapaPedido.tabelaprecoid;
    },
    async naturezaAtualPedido(capa, endereco) {
      // A simulação resolve natureza e cadastro fiscal pelo ID local no servidor.
      // Não consultar InfoPedido: editar um pedido autorizado não exige que
      // seu cliente esteja na carteira de criação do aprovador.
      if (!/^\d+$/.test(String(capa?.clienteid || ''))) {
        throw new Error('Pedido sem identificação local do cliente para cálculo fiscal.');
      }
      return '';
    },
    categoriaPedidoPersistida() {
      return this.getCapaPedido?.tipopedidoid
        || this.getCapaPedido?.tipoPedidoId
        || this.getCapaPedido?.tipoPedido?.tipopedidoid
        || '';
    },
    itensPedidoPersistidosCategoria() {
      return this.getItensPedido || [];
    },
    async prepararItemParaAdicionar(item) {
      if (this.preparandoAdicao) return null;
      this.preparandoAdicao = true;
      try {
        const generation = ++this.categoryCalculationGeneration;
        const usaCategoria = this.categoriaClienteAtiva();
        const categorizado = usaCategoria ? await this.identificarCategoriaItemCliente(item) : item;
        if (!categorizado || generation !== this.categoryCalculationGeneration) return null;
        const impostos = await this.calcularImposto({
          item_id: categorizado.item_id,
          precoUnitario: categorizado.precoUnitario,
          valor: categorizado.valor,
          categoria_tipo_pedido: categorizado.categoria_tipo_pedido,
        });
        if (generation !== this.categoryCalculationGeneration) return null;
        const preco = Number(impostos?.precoComImposto);
        if (!Number.isFinite(preco) || preco <= 0) {
          this.avisarPrecoInvalido();
          return null;
        }
        if (usaCategoria && !this.confirmarCategoriaItemCliente(categorizado)) return null;
        return {
          ...categorizado,
          precoComImposto: preco,
          precoTabelaErp: impostos.precoTabelaErp,
          baseIcms: impostos.baseIcms,
          valorIcms: impostos.valorIcms,
          naturezaoperacaoidimposto: impostos.naturezaoperacaoidimposto,
        };
      } catch (error) {
        this.avisarPrecoInvalido();
        return null;
      } finally {
        this.preparandoAdicao = false;
      }
    },
    avisarPrecoInvalido() {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Produto não adicionado',
          text: 'O cálculo de impostos não retornou um valor válido maior que zero. Tente novamente antes de adicionar.',
          icon: 'AlertTriangleIcon',
          variant: 'warning',
        },
      });
    },
    async simularImpostoBackend({ itemId, quantidade = 1, precoBase }) {
      if (!itemId || !precoBase) return null;

      const capaPedido = this.getCapaPedido || {};
      const enderecoEntrega = this.getEnderecoEntrega || {};
      const estabelecimentoid = capaPedido?.estabelecimentoId || capaPedido?.estabelecimentoid || '';
      const naturezaoperacaoid = await this.naturezaAtualPedido(capaPedido, enderecoEntrega);
      const canalVendaId = capaPedido?.canalvendaid || '';
      const ufDs = capaPedido?.pedidoentregauf || enderecoEntrega?.ufid || capaPedido?.ufid || '';
      const cidadeDs = capaPedido?.pedidoentregacidade || enderecoEntrega?.clienteenderecocidade || '';
      const tabelaPrecoId = capaPedido?.tabelaprecoid || '';
      const condicaoPagamentoId = Number(capaPedido?.condicaopagamentoid || 0);
      const clienteNomeAbreviado = capaPedido?.clientenomeabreviado || '';

      if (!estabelecimentoid || !clienteNomeAbreviado || !tabelaPrecoId || (this.$store.getters['preferencias/condicaoPagamentoAtiva'] && !condicaoPagamentoId)) {
        return null;
      }

      const { data: resp } = await apiAxios.post('imposto/simular', {
        estabelecimentoid,
        clienteId: capaPedido?.clienteid,
        clienteNomeAbreviado,
        naturezaOperacaoId: naturezaoperacaoid,
        canalVendaId,
        itemId,
        quantidade,
        precoUnitario: precoBase,
        ufDs,
        cidadeDs,
        contribuinteIcms: capaPedido?.clienteisentoie == null
          ? undefined
          : (capaPedido.clienteisentoie ? 0 : 1),
        tabelaPrecoId,
        condicaoPagamentoId,
      });

      const resultado = aplicarPrecoDoacao(
        resp?.data,
        isPedidoDoacao({ dataCapaPedido: capaPedido }),
        capaPedido.tipopedidoid,
      );
      if (resp?.success === false || !resultado || resultado._erro) return null;
      this.registrarCotacaoVisual(itemId, resultado);

      const precoComImposto = precoFinalSimulado(resultado);
      if (!Number.isFinite(precoComImposto) || precoComImposto <= 0) return null;

      return {
        precoComImposto,
        precoTabelaErp: precoTabelaSimulado(resultado),
        descontoConfirmado: precoComDescontoConfirmado(resultado),
        baseIcms: Number(resultado.baseIcms || 0),
        valorIcms: Number(resultado.valorIcms || 0),
        naturezaoperacaoidimposto: resultado.naturezaOperacao || null,
      };
    },
    async carregarDetalheReferencia(product) {
      if (!product || product._detalheCarregado || product._carregandoDetalhe) return;
      const selectedSku = product.item_id ?? product.itemId ?? product.CodItem;
      this.atualizarItemJsonTelaNovaPedido({ referencia: product.referencia, itemId: selectedSku, patch: { _carregandoDetalhe: true } });
      try {
        // Cache para simulação de impostos para evitar múltiplas chamadas iguais
        const impostoCache = {};

        const simularImpostoWithCache = async ({ skuId, precoBase }) => {
          if (!skuId || !precoBase) return null;

          const capaPedido = this.getCapaPedido || {};
          const enderecoEntrega = this.getEnderecoEntrega || {};

          const estabelecimentoid = capaPedido?.estabelecimentoId || capaPedido?.estabelecimentoid || '';
          const naturezaoperacaoid = await this.naturezaAtualPedido(capaPedido, enderecoEntrega);
          const canal_venda_id = capaPedido?.canalvendaid || '';
          const ufid = enderecoEntrega?.ufid || capaPedido?.ufid || '';
          const cidade = enderecoEntrega?.clienteenderecocidade || '';
          const isentoIE = capaPedido?.clienteisentoie ? 1 : 0;
          const tabelaprecoid = capaPedido?.tabelaprecoid || '';
          const condicaopagamentoid = Number(capaPedido?.condicaopagamentoid || 0);
          const nomeCliente = capaPedido?.clientenomeabreviado || capaPedido?.clienteid || '';

          if (!estabelecimentoid || !tabelaprecoid || (this.$store.getters['preferencias/condicaoPagamentoAtiva'] && !condicaopagamentoid) || !nomeCliente) {
            return null;
          }

          const cacheKey = [skuId, precoBase, estabelecimentoid, naturezaoperacaoid, canal_venda_id, ufid, cidade, isentoIE, tabelaprecoid, condicaopagamentoid].join('|');
          if (impostoCache[cacheKey]) return impostoCache[cacheKey];

          try {
            const result = await this.simularImpostoBackend({
              itemId: skuId,
              quantidade: 1,
              precoBase,
            });
            impostoCache[cacheKey] = result;
            return result;
          } catch (e) {
            console.warn('Falha ao simular imposto (pré)', e);
            return null;
          }
        };

        const refCode = product.referencia ?? 0;
        const detalhes = await this.getDetalhesItem(
          refCode, product.cod_marca, product.cod_categ, selectedSku,
        );

        if (!detalhes || !detalhes.Result) {
          this.atualizarItemJsonTelaNovaPedido({ referencia: product.referencia, itemId: selectedSku, patch: { _detalheCarregado: true } });
          return;
        }

        const itemData = detalhes.Result?.data?.Result
          || detalhes.Result?.data
          || detalhes.Result?.Result
          || detalhes.Result
          || detalhes.data?.Result
          || detalhes.data || {};
        const exactItem = itemData?.item || {};

        // Ignorar respostas "vazias" (apenas Marca preenchida e demais blocos nulos)
        const isEmptyResponse = (
          !itemData?.imagens
          && !itemData?.Embalagens
          && !itemData?.corTamanho
          && !itemData?.tabelaPreco
          && !itemData?.familiaComercial
        );
        if (isEmptyResponse || !itemData) {
          console.warn(`Referência ${refCode} sem dados detalhados úteis.`);
          this.atualizarItemJsonTelaNovaPedido({ referencia: product.referencia, itemId: selectedSku, patch: { _detalheCarregado: true } });
          return;
        }

        const tabelaPrecoArr = Array.isArray(itemData.tabelaPreco) ? itemData.tabelaPreco : null;
        const precoBaseNum = parseFloat(
          tabelaPrecoArr?.[0]?.tabelapreco_item_preco
            ?? tabelaPrecoArr?.[0]?.preco ?? exactItem.preco ?? product.item_price_base ?? product.item_price ?? 0,
        );
        const precoBase = Number.isFinite(precoBaseNum) ? precoBaseNum : 0;

        if (!tabelaPrecoArr || tabelaPrecoArr.length === 0) {
          console.log(`Atenção: Referência ${refCode} não possui tabela de preço válida.`);
        }

        const corTamanhoArr = Array.isArray(itemData.corTamanho) ? itemData.corTamanho : [];
        const gradeBuilt = (() => {
          const ttHBIgrade = corTamanhoArr.map((row) => ({
            cdnCor: row.cdn_cor,
            desCor: row.des_cor,
            itemExtrapq: row.pp?.item_id || null,
            itemPequeno: row.p?.item_id || null,
            itemMedio: row.m?.item_id || null,
            itemGrande: row.g?.item_id || null,
            itemExtraGd: row.gg?.item_id || null,
            itemSuperGd: row.xg?.item_id || null,
            itemUltraGd: row.xgg?.item_id || null,
            itemUnico: row.unico?.item_id || null,
            itemOutros: row.diversos?.item_id || null,
          })).filter((r) => r.cdnCor || r.desCor);
          return ttHBIgrade.length > 0 ? { dsHBIgrade: { ttHBIgrade } } : null;
        })();

        const embalagensProcessadas = (Array.isArray(itemData.Embalagens) ? itemData.Embalagens : []).map((embalagem) => ({
          descricao_embalagem: embalagem.des_embalag,
          cdn_embalagem: embalagem.cdn_embalagem,
          grade: gradeBuilt,
          itemMultiplo: 0,
        }));

        const imagensArr = Array.isArray(itemData.imagens) ? itemData.imagens : [];
        const imagemPrincipal = imagensArr.find((img) => img.imagemPrincipal === 1);
        const caminhoImagemPrincipal = imagemPrincipal ? imagemPrincipal.caminho : null;

        // The selected row is already one exact SKU; never replace it with
        // the first sibling found in the family grade.
        const firstSkuIdLocal = selectedSku;

        let precoComImposto = null;
        let precoTabelaErp = null;
        let descontoConfirmado = false;
        let baseIcms = null;
        let valorIcms = null;
        let naturezaoperacaoidimposto = null;
        try {
          if (firstSkuIdLocal) {
            const imposto = await simularImpostoWithCache({ skuId: firstSkuIdLocal, precoBase });
            if (imposto) {
              precoComImposto = imposto.precoComImposto;
              precoTabelaErp = imposto.precoTabelaErp;
              descontoConfirmado = imposto.descontoConfirmado;
              baseIcms = imposto.baseIcms;
              valorIcms = imposto.valorIcms;
              naturezaoperacaoidimposto = imposto.naturezaoperacaoidimposto;
            }
          }
        } catch (e) {
          console.warn('Falha na pré-simulação de imposto para referência', refCode, e);
        }

        const fam0 = itemData.familiaComercial?.[0] || {};
        const marca0 = itemData.Marca?.[0] || {};
        const familiaItemId = fam0.item_id || 0;
        const selectedDescricao = product.item_descricao ?? product.itemDescricao
          ?? product.Descricao ?? exactItem.item_descricao ?? exactItem.itemDescricao
          ?? itemData.item_descricao ?? itemData.itemDescricao
          ?? fam0.Referencia ?? product.item_name;

        this.atualizarItemJsonTelaNovaPedido({
          referencia: product.referencia,
          itemId: selectedSku,
          patch: {
            item_name: selectedDescricao,
            item_descricao: selectedDescricao,
            itemDescricao: selectedDescricao,
            Descricao: itemData.Descricao ?? selectedDescricao,
            item_price_base: (Number.isFinite(precoBase) ? precoBase : 0).toFixed(2),
            item_price: (precoComImposto !== null && Number.isFinite(precoComImposto) ? precoComImposto : (Number.isFinite(precoBase) ? precoBase : 0)).toFixed(2),
            item_marca: marca0.des_marca || exactItem.item_marca || product.item_marca,
            cod_marca: marca0.cod_marca || exactItem.cod_marca || product.cod_marca || this.selected_cod_marca || null,
            imagens: imagensArr,
            item_img_princial: caminhoImagemPrincipal,
            embalagens: (embalagensProcessadas || []).filter(Boolean),
            precoComImposto: Number.isFinite(precoComImposto) ? precoComImposto : null,
            precoTabelaErp,
            descontoConfirmado,
            baseIcms,
            valorIcms,
            naturezaoperacaoidimposto,
            familiaItemId,
            // SKU único (produtos sem grade de cor/tamanho, ex.: livros): guarda o
            // item_id direto + cor "padrão" para o fluxo "somente quantidade".
            itemIdUnico: selectedSku,
            cdnCorUnico: product.cdn_cor ?? exactItem.cdn_cor
              ?? corTamanhoArr.find((row) => row?.cdn_cor)?.cdn_cor ?? 0,
            desCorUnico: product.des_cor ?? exactItem.des_cor
              ?? corTamanhoArr.find((row) => row?.des_cor)?.des_cor ?? null,
            cdnTamanhoUnico: product.cdn_tamanho ?? exactItem.cdn_tamanho ?? null,
            desTamanhoUnico: product.des_tamanho ?? exactItem.des_tamanho ?? null,
            cdnEmbalagemUnico: product.cdn_embalagem ?? exactItem.cdn_embalagem ?? null,
            desEmbalagemUnico: product.des_embalag ?? exactItem.des_embalag ?? null,
            _detalheCarregado: true,
          },
        });

        if (selectedSku) {
          try {
            await new SLSEstoqueService().consultarEstoque([String(selectedSku)]);
          } catch (e) {
            console.warn('[modalAdicionarEditarItens] Falha ao consultar estoque:', e);
          }
        }
      } catch (error) {
        console.error(`Erro ao carregar detalhe da referência ${product?.referencia}:`, error);
          this.atualizarItemJsonTelaNovaPedido({ referencia: product.referencia, itemId: selectedSku, patch: { _detalheCarregado: true } });
      } finally {
          this.atualizarItemJsonTelaNovaPedido({ referencia: product.referencia, itemId: selectedSku, patch: { _carregandoDetalhe: false } });
      }
    },
    async calcularImposto(newItem) {
      Swal.fire({
        title: 'Calculando impostos',
        html: 'Por favor, aguarde...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      this.isCalculandoImposto = true;

      try {
        const capaPedido = this.getCapaPedido || {};
        const enderecoEntrega = this.getEnderecoEntrega || {};
        const estabelecimentoid = capaPedido?.estabelecimentoId || capaPedido?.estabelecimentoid || '';
        const naturezaoperacaoid = await this.naturezaAtualPedido(capaPedido, enderecoEntrega);
        const canal_venda_id = capaPedido?.canalvendaid || '';
        const ufid = enderecoEntrega?.ufid || capaPedido?.ufid || '';
        const cidade = enderecoEntrega?.clienteenderecocidade || '';
        const isentoIE = capaPedido?.clienteisentoie ? 1 : 0;
        const tabelaprecoid = capaPedido?.tabelaprecoid || '';
        const condicaopagamentoid = Number(capaPedido?.condicaopagamentoid || 0);
        const nomeCliente = capaPedido?.clientenomeabreviado || capaPedido?.clienteid || '';

        if (!estabelecimentoid || !nomeCliente || !tabelaprecoid || (this.$store.getters['preferencias/condicaoPagamentoAtiva'] && !condicaopagamentoid)) {
          throw new Error('Não foi possível calcular impostos. Tente novamente.');
        }

        const imposto = await this.simularImpostoBackend({
          itemId: newItem.item_id,
          quantidade: newItem.valor,
          precoBase: newItem.precoUnitario,
        });

        if (imposto) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Sucesso',
              text: 'Imposto calculado com sucesso!',
              icon: 'CheckIcon',
              variant: 'success',
            },
          });

          return {
            precoComImposto: imposto.precoComImposto,
            precoTabelaErp: imposto.precoTabelaErp,
            baseIcms: imposto.baseIcms,
            valorIcms: imposto.valorIcms,
            naturezaoperacaoidimposto: imposto.naturezaoperacaoidimposto,
          };
        }
        return null;
      } catch (error) {
        console.error('Erro ao calcular impostos:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: error.message || 'Erro ao calcular impostos',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });

        return null;
      } finally {
        Swal.close();
        this.isCalculandoImposto = false;
      }
    },
    async show(type, item) {
      await this.$bvModal.show('modal_novo_itens');
      this.$root.$emit('modal:opened');
      this.$root.$emit('modal:sync-items');
      await this.getMarcaPedido();

      if (type === 'editar') {
        this.selected_cod_marca = await item.item.cod_marca;
        await this.getCategoriaPedido().then(() => {
          this.selected_cod_marca = item.item.cod_marca;
          this.selected_categoria = item.item.cod_categ;
        });

        await this.buscarReferencias().then(() => {
          this.selected_referencia = item.item.cod_referencia;
        });
        await this.buscaCorGradeItens(item.subItens);
      }
    },
    async resetModal() {
      this.cotacoesVisuais = {};
      this.categoryCalculationGeneration += 1;
      this.tipoBusca = 'marca-categoria';
      // Carrega as options dos filtros de atributo (língua, segmento, etc.)
      this.limparFiltrosAtributo();
      this.carregarFiltrosItens();
      this.selected_cod_marca = null;
      this.selected_categoria = null;
      this.selected_referencia = null;
      this.selected_embalagem = null;
      this.valorUnitario = null;
      this.busca_referencia = '';
      this.codigo_referencia_direto = '';
      this.referenciasPendentes = [];
      this.clearModalItens();
      this.novosItensAdicionados = false;
      this.itensTabela = [];
    },
    async updatedGradeItens(value) {
      console.log('updatedGradeItens', value);

      if (!value || value.length === 0) return;

      const novoItem = value[value.length - 1];
      if (!Number.isFinite(Number(novoItem?.precoComImposto)) || Number(novoItem.precoComImposto) <= 0) {
        this.avisarPrecoInvalido();
        return;
      }
      const itemMultiplo = parseInt(novoItem.itemMultiplo || 1);

      // Verificar se a quantidade é múltipla quando itemMultiplo > 1
      if (itemMultiplo > 1) {
        const quantidade = parseInt(novoItem.valor, 10);
        if (quantidade % itemMultiplo !== 0) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Quantidade inválida',
              text: `A quantidade deve ser múltipla de ${itemMultiplo}`,
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
          return;
        }
      }

      // Verificar se o item já existe na tabela
      const itemExistente = this.itensTabela.find((item) => item.itemId === novoItem.item_id
        && item.des_cor === novoItem.des_cor
        && item.desc_tamanho === novoItem.tamanho
        && item.cdn_embalagem === novoItem.cdn_embalagem);

      if (itemExistente) {
        // Se o item já existe, apenas atualizar a quantidade
        const valorAntigo = itemExistente.pedidoItemQuantidade;
        const novaQuantidade = parseInt(novoItem.valor);

        // Verificar se a nova quantidade é múltiplo válido
        const itemMultiplo = parseInt(itemExistente.itemMultiplo || 1);

        if (itemMultiplo > 1) {
          if (novaQuantidade % itemMultiplo !== 0) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Quantidade inválida',
                text: `A quantidade deve ser múltipla de ${itemMultiplo}`,
                icon: 'AlertTriangleIcon',
                variant: 'warning',
              },
            });
            return;
          }
        }

        itemExistente.pedidoItemQuantidade = novaQuantidade;
        itemExistente.valorTotal = novaQuantidade * itemExistente.precoUnitario;
        itemExistente.valorTotalComImposto = novaQuantidade * (itemExistente.precoComImposto || itemExistente.precoUnitario);
      } else {
        // Se é um novo item, tentar usar pré-simulação existente
        const precoBase = parseFloat(novoItem.item_price_base || novoItem.precoUnitario || novoItem.item_price || 0);
        let precoExibicao = parseFloat(novoItem.item_price ?? novoItem.precoComImposto ?? novoItem.precoUnitario ?? precoBase);

        let precoComImposto = novoItem.precoComImposto == null ? null : parseFloat(novoItem.precoComImposto);
        let baseIcms = novoItem.baseIcms || null;
        let valorIcms = novoItem.valorIcms || null;
        let naturezaoperacaoidimposto = novoItem.naturezaoperacaoidimposto || null;

        if (precoComImposto === null) {
          const impostos = await this.calcularImposto({
            item_id: novoItem.item_id,
            precoUnitario: precoBase,
            valor: 1,
          });
          if (impostos) {
            precoComImposto = parseFloat(impostos.precoComImposto);
            novoItem.precoTabelaErp = impostos.precoTabelaErp;
            baseIcms = impostos.baseIcms;
            valorIcms = impostos.valorIcms;
            naturezaoperacaoidimposto = impostos.naturezaoperacaoidimposto;
            precoExibicao = precoComImposto ?? precoExibicao;
          }
        }
        if (Number.isFinite(precoComImposto) && precoComImposto > 0) precoExibicao = precoComImposto;

        const quantidade = parseInt(novoItem.valor, 10);

        const newItem = {
          codMarca: this.selected_cod_marca,
          familiaComercialId: novoItem.referencia,
          cdncor: novoItem.cdn_cor,
          des_cor: novoItem.des_cor,
          cdn_tamanho: novoItem.tamanho,
          itemId: novoItem.item_id,
          item_id: novoItem.item_id,
          item_descricao: `${novoItem.nome} ${novoItem.tamanho} ${novoItem.des_cor}`,
          descricao_referencia: novoItem.nome,
          pedidoItemQuantidade: quantidade,
          marca: novoItem.marca,
          embalagem: novoItem.embalagem,
          cdn_embalagem: novoItem.cdn_embalagem,
          precoUnitarioBase: precoBase,
          precoUnitario: precoExibicao,
          precoTabelaErp: novoItem.precoTabelaErp,
          precoComImposto: precoComImposto || null,
          baseIcms,
          valorIcms,
          naturezaoperacaoidimposto,
          valorTotal: precoExibicao * quantidade,
          valorTotalComImposto: (precoComImposto || precoExibicao) * quantidade,
          desc_tamanho: novoItem.tamanho,
          tamanho: novoItem.tamanho,
          pedidoItemQuantidadeSaldo: 0,
          pedidoItemQuantidadeFaturada: 0,
          pedidoitemseq: 0,
          itemMultiplo: novoItem.itemMultiplo || 1,
          categoria_tipo_pedido: novoItem.categoria_tipo_pedido,
          novoItem: true,
        };

        this.itensTabela.push(newItem);
      }

      this.novosItensAdicionados = this.itensTabela.length > 0;
    },
    handleOk(event) {
      event?.preventDefault();
      if (!this.podeSalvarItens) {
        this.avisarPrecoInvalido();
        return;
      }
      return adicionarProdutoModalMixin.methods.handleOk.call(this, event);
    },
    async addItens() {
      if (!this.podeSalvarItens) {
        this.avisarPrecoInvalido();
        return;
      }
      console.log('addItens', this.itensTabela);

      const itensAgrupadosPorReferencia = this.itensTabela.reduce((acc, item) => {
        const referencia = item.familiaComercialId;
        if (!acc[referencia]) {
          acc[referencia] = {
            CodMarca: item.codMarca,
            DescricaoMarca: item.marca,
            CodReferencia: referencia,
            DescricaoReferencia: item.descricao_referencia,
            referencia: `${referencia}-${item.item_descricao}`,
            Qtde: 0,
            PrecoUnitario: item.precoUnitario,
            ValorTotal: 0,
            PrecoComImposto: item.precoComImposto || item.precoUnitario || 0,
            BaseIcms: 0,
            ValorIcms: 0,
            sequencia: Object.keys(acc).length + 1,
            itens: [],
            editar: {
              cod_marca: item.codMarca,
              cod_categ: this.selected_categoria,
              cod_referencia: referencia,
              precoId: this.getCapaPedido.tabelaprecoid,
            },
          };
        }
        acc[referencia].Qtde += item.pedidoItemQuantidade;
        acc[referencia].ValorTotal += item.pedidoItemQuantidade * item.precoUnitario;
        acc[referencia].BaseIcms += (item.baseIcms || 0) * item.pedidoItemQuantidade;
        acc[referencia].ValorIcms += (item.valorIcms || 0) * item.pedidoItemQuantidade;
        acc[referencia].valorTotalComImposto = (item.precoComImposto || item.precoUnitario || item.precoUnitarioBase) * item.pedidoItemQuantidade;

        acc[referencia].itens.push({
          ...item,
          precoComImposto: item.precoComImposto || item.precoUnitario || 0,
          baseIcms: item.baseIcms || 0,
          valorIcms: item.valorIcms || 0,
          valorTotalComImposto: (item.precoComImposto || item.precoUnitario || item.precoUnitarioBase) * item.pedidoItemQuantidade,
          naturezaoperacaoidimposto: item.naturezaoperacaoidimposto,
        });

        return acc;
      }, {});

      console.log('itensAgrupadosPorReferencia com impostos', itensAgrupadosPorReferencia);

      for (const referencia in itensAgrupadosPorReferencia) {
        const item = itensAgrupadosPorReferencia[referencia];
        await this.setItensTabelaPedido(item);
      }
    },
  },
};
</script>

<style scoped>
.container-images-prod {
  width: 500px;
}

.loading-indicator {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  justify-content: center;
}

/* Filtros de atributo (Língua, Segmento, Nível educacional…):
   label fica em uma linha só e o select alinha à base dos demais. */
.filtro-atributo-group ::v-deep label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.modal-add-product {
  --map-primary: var(--sf-accent, #2563eb);
}

.client-info-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: var(--sf-accent, #2563eb);
  color: white;
  padding: 0.75rem 1rem;
  margin-bottom: 1.5rem;
  border-radius: 4px;

  .client-info {
    display: flex;
    align-items: center;
    gap: 0.75rem;

    feather-icon {
      opacity: 0.9;
    }
  }

  .order-info {
    display: flex;
    gap: 1.5rem;
  }

  .info-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .info-content {
    display: flex;
    flex-direction: column;
    line-height: 1.1;

    .label {
      font-size: 0.65rem;
      opacity: 0.8;
      text-transform: uppercase;
      font-weight: 500;
      letter-spacing: 0.5px;
    }

    .value {
      font-size: 0.85rem;
      font-weight: 600;
      color: white;
    }
  }
}

.modal-actions-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid var(--sf-border-color, #e2e8f0);

  .items-summary {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 0.75rem;
    background: var(--sf-surface-secondary, #f8fafc);
    border-radius: 6px;

    .summary-count {
      font-weight: 600;
      color: var(--sf-accent, #2563eb);
      font-size: 0.9rem;
    }

    .summary-separator {
      color: var(--sf-border-color, #cbd5e1);
    }

    .summary-total {
      font-weight: 600;
      color: var(--sf-text-primary, #334155);
    }
  }

  .actions-buttons {
    display: flex;
    gap: 0.75rem;
  }
}

:global(body.dark-layout) {
  .client-info-bar {
    background: var(--sf-accent-dark, #5e50ee);
  }
}
</style>
